import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { StandardFieldProps } from './FieldTypes';
import HelperText from './HelperText';

const StandardJsonField = ({
  control,
  fieldName,
  field,
  readOnly,
}: StandardFieldProps) => (
  <Controller
    name={fieldName}
    control={control}
    render={({
      field: { onChange, onBlur, value },
      fieldState: { error },
    }) => {
      const displayValue =
        value == null || value === ''
          ? null
          : typeof value === 'string'
            ? (() => {
                try {
                  return JSON.parse(value);
                } catch {
                  return value;
                }
              })()
            : value;
      const jsonString =
        displayValue == null
          ? ''
          : typeof displayValue === 'object'
            ? JSON.stringify(displayValue, null, 2)
            : String(displayValue);

      return (
        <>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
            {field?.label ?? fieldName}
          </Typography>
          <Box
            sx={{
              mt: 0.5,
              p: 2,
              bgcolor: 'action.hover',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            {readOnly ? (
              <Typography
                component="pre"
                variant="body2"
                sx={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  fontFamily: 'monospace',
                  m: 0,
                }}
              >
                {jsonString || '—'}
              </Typography>
            ) : (
              <TextField
                fullWidth
                multiline
                minRows={3}
                id={fieldName}
                name={fieldName}
                value={jsonString}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === '') {
                    onChange(null);
                    return;
                  }
                  try {
                    onChange(JSON.parse(raw));
                  } catch {
                    onChange(raw);
                  }
                }}
                onBlur={onBlur}
                error={Boolean(error)}
                placeholder="{}"
                inputProps={{
                  spellCheck: false,
                  style: { fontFamily: 'monospace' },
                }}
              />
            )}
          </Box>
          <HelperText
            name={fieldName}
            error={error?.message}
            description={field?.description}
          />
        </>
      );
    }}
  />
);

export default StandardJsonField;
